export function convertToChildrenArray(children: { [key: string]: boolean }) {
  return Object.entries(children)
    .filter((el) => el[1])
    .map((el) => {
      return {
        persona_id: parseInt(el[0].split('_')[0]),
      }
    })
}
